import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["id", "type", "className", "children", "maxLength", "title", "showAttachment", "placeholderWithContent", "placeholderWithoutContent", "commentsContent", "disabled", "addBtnName", "onCloseClick", "onAddClick", "onMoreClick", "onCommentContentChange", "renderCommentList"];
import * as React from "react";
import { Button } from "../button";
import { TextArea } from "../field";
import { KEY_VALUES, mergeRefs, useControlled } from "../utils";
import ClassNames from "classnames";
var FeedsComments = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var id = props.id,
    type = props.type,
    className = props.className,
    children = props.children,
    maxLength = props.maxLength,
    _props$title = props.title,
    title = _props$title === void 0 ? "Add a new comment" : _props$title,
    _props$showAttachment = props.showAttachment,
    showAttachment = _props$showAttachment === void 0 ? false : _props$showAttachment,
    _props$placeholderWit = props.placeholderWithContent,
    placeholderWithContent = _props$placeholderWit === void 0 ? "Your comment" : _props$placeholderWit,
    _props$placeholderWit2 = props.placeholderWithoutContent,
    placeholderWithoutContent = _props$placeholderWit2 === void 0 ? "Write a comment..." : _props$placeholderWit2,
    commentsContentProp = props.commentsContent,
    disabled = props.disabled,
    _props$addBtnName = props.addBtnName,
    addBtnName = _props$addBtnName === void 0 ? "Add comment" : _props$addBtnName,
    onCloseClick = props.onCloseClick,
    onAddClick = props.onAddClick,
    onMoreClick = props.onMoreClick,
    onCommentContentChange = props.onCommentContentChange,
    renderCommentList = props.renderCommentList,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  var safariAgent = navigator.userAgent.indexOf("Safari") > -1 && navigator.vendor.indexOf("Apple") > -1;
  var fileInputRef = React.useRef(null);
  var feedsRef = React.useRef(null);
  var _useControlled = useControlled(commentsContentProp, ""),
    commentsContent = _useControlled[0],
    setCommentsContent = _useControlled[1];
  var handleCommentChange = function handleCommentChange(value) {
    setCommentsContent(value);
    onCommentContentChange === null || onCommentContentChange === void 0 ? void 0 : onCommentContentChange(value);
  };
  var handleOnMoreClick = function handleOnMoreClick(event) {
    onMoreClick === null || onMoreClick === void 0 ? void 0 : onMoreClick(event);
  };
  var handleOnAddClick = function handleOnAddClick() {
    onAddClick === null || onAddClick === void 0 ? void 0 : onAddClick({
      commentsContent: commentsContent,
      uploadedFiles: uploadedFiles,
      fileImageUrls: fileImageUrls
    });
    setFileImageUrls([]);
    setUploadedFiles([]);
    setCommentsContent("");
    onCommentContentChange === null || onCommentContentChange === void 0 ? void 0 : onCommentContentChange("");
  };
  var handleOnCloseClick = function handleOnCloseClick(event) {
    onCloseClick === null || onCloseClick === void 0 ? void 0 : onCloseClick(event);
  };
  var attach = function attach() {
    var _fileInputRef$current;
    //@ts-ignore

    fileInputRef === null || fileInputRef === void 0 ? void 0 : (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.click();
  };
  var imgList = [1, 2, 3, 4];
  var _React$useState = React.useState([]),
    fileImageUrls = _React$useState[0],
    setFileImageUrls = _React$useState[1];
  var _React$useState2 = React.useState([]),
    uploadedFiles = _React$useState2[0],
    setUploadedFiles = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    target = _React$useState3[0],
    setTarget = _React$useState3[1];
  var handleChange = function handleChange(event) {
    var newTarget = event.target || event.srcElement;
    var imageFile = event.target.files[0];
    if (imageFile) {
      var imgUrl = window.URL.createObjectURL(imageFile);
      var _fileImageUrls = [].concat(fileImageUrls, [imgUrl]);
      var _uploadedFiles = [].concat(uploadedFiles, [imageFile]);
      setFileImageUrls(_fileImageUrls);
      setUploadedFiles(_uploadedFiles);
      newTarget.value = '';
    }
    setTarget(newTarget);
  };
  var updateFocusAfterDelete = function updateFocusAfterDelete(index) {
    var deleteIcons = feedsRef.current.querySelectorAll('.Appkit4-icon.icon-circle-delete-outline');
    if (deleteIcons && deleteIcons.length > 0 && index > 0) {
      deleteIcons[index - 1].focus();
    } else if (deleteIcons && index === 0) {
      if (deleteIcons.length < 2) {
        var attachButton = feedsRef.current.querySelector('.ap-feeds-comments-footer-attach-input');
        attachButton.focus();
      } else {
        deleteIcons[1].focus();
      }
    }
  };
  var deleteImg = function deleteImg(index, event) {
    if (event && event.key !== KEY_VALUES.ENTER) return;
    updateFocusAfterDelete(index);
    var _fileImageUrls = [].concat(fileImageUrls);
    _fileImageUrls.splice(index, 1);
    var _uploadedFiles = [].concat(uploadedFiles);
    _uploadedFiles.splice(index, 1);
    setFileImageUrls(_fileImageUrls);
    setUploadedFiles(_uploadedFiles);
  };
  if (type === 'comments') return /*#__PURE__*/React.createElement("div", _extends({
    ref: mergeRefs(ref, feedsRef),
    className: ClassNames("comments-wrapper", className)
  }, otherProps), renderCommentList === null || renderCommentList === void 0 ? void 0 : renderCommentList());else return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    ref: mergeRefs(ref, feedsRef),
    className: ClassNames("ap-feeds-comments", className)
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    className: "ap-feeds-comments-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-feeds-comments-header-title"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "ap-feeds-comments-body"
  }, /*#__PURE__*/React.createElement(TextArea, {
    maxLength: maxLength,
    title: commentsContent.length > 0 ? placeholderWithContent : placeholderWithoutContent,
    value: commentsContent,
    onChange: handleCommentChange,
    disabled: disabled
  })), /*#__PURE__*/React.createElement("div", {
    className: "ap-feeds-comments-footer-wrapper"
  }, showAttachment && /*#__PURE__*/React.createElement("div", {
    className: "ap-feeds-comments-footer-wrapper-attach",
    "aria-label": "attach link",
    role: "button"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: "Appkit4-icon icon-paperclip-outline"
  }), /*#__PURE__*/React.createElement("input", {
    className: "ap-feeds-comments-footer-attach-input",
    "aria-label": "attach link",
    ref: fileInputRef,
    type: "file",
    accept: "image/*",
    "aria-hidden": "true",
    tabIndex: undefined,
    onChange: function onChange(e) {
      return handleChange(e);
    }
  })), !showAttachment && /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("div", {
    className: "ap-feeds-comments-footer-buttons"
  }, /*#__PURE__*/React.createElement(Button, {
    kind: "primary",
    disabled: !commentsContent && showAttachment && !fileImageUrls.length || !commentsContent && !showAttachment,
    onClick: handleOnAddClick
  }, addBtnName))), fileImageUrls.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "uploaded-images"
  }, /*#__PURE__*/React.createElement("div", {
    className: "uploaded-images-placeholder"
  }, imgList.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: ClassNames("uploaded-images-placeholder-item", {
        "rimless": index >= fileImageUrls.length
      })
    });
  })), fileImageUrls.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "image-wrapper"
    }, /*#__PURE__*/React.createElement("img", {
      src: item,
      alt: "'uploaded-image '+(index+1)"
    }), /*#__PURE__*/React.createElement("span", {
      className: "Appkit4-icon icon-circle-delete-outline",
      onClick: function onClick(e) {
        return deleteImg(index);
      },
      onKeyDown: function onKeyDown(e) {
        return deleteImg(index, e);
      },
      tabIndex: 0,
      role: "button",
      "aria-label": "'Delete image '+(index+1)"
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "ap-comment-header-action"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-feeds-comments-header-action"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "More info",
    type: "button",
    className: "more",
    onClick: handleOnMoreClick
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: "Appkit4-icon icon-horizontal-more-outline"
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": "cancel",
    type: "button",
    className: "close",
    onClick: handleOnCloseClick
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: "Appkit4-icon icon-close-outline"
  })))));
});
export default FeedsComments;